/**
 * Octopus - Paleta de severidade de alertas (fonte única).
 *
 * Extraído de AlertsPage.jsx (Central de Alertas, phase 999.8) para um módulo
 * compartilhado — importado pela Central E pelos badges do "Ao vivo"
 * (EngineNotificationBadges) para garantir ZERO drift de paleta entre as duas
 * superfícies (D-01). Não redefinir este objeto em outro lugar; sempre importar
 * daqui. Severidade vem SEMPRE curada do backend (INV-UI-TRAIL-001) — o cliente
 * apenas mapeia severity → apresentação, nunca a deriva do state cru.
 */
import { AlertCircle, AlertTriangle, Info } from 'lucide-react';

export const severityConfig = {
  critical: { icon: AlertCircle, color: 'text-red-500', bg: 'bg-red-500/10', border: 'border-red-500', label: 'Crítica' },
  high: { icon: AlertTriangle, color: 'text-orange-500', bg: 'bg-orange-500/10', border: 'border-orange-500', label: 'Alta' },
  medium: { icon: AlertTriangle, color: 'text-yellow-500', bg: 'bg-yellow-500/10', border: 'border-yellow-500', label: 'Média' },
  low: { icon: Info, color: 'text-blue-500', bg: 'bg-blue-500/10', border: 'border-blue-500', label: 'Baixa' },
};
